interface MetricCardProps {
    label: string;
    value: string;
    sub?: string;
}

export function MetricCard({ label, value, sub }: MetricCardProps) {
    return (
        <div className="bg-okiru-panel border border-okiru-muted/15 rounded-xl p-5">
            <div className="text-xs text-okiru-muted uppercase tracking-wide">{label}</div>
            <div className="text-3xl font-semibold mt-2">{value}</div>
            {sub && <div className="text-sm text-okiru-muted mt-1">{sub}</div>}
        </div>
    );
}
